export default __webpack_public_path__ + "static/media/kitchen3-afterD-1920w.00a33e29.avif";